export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8236.e5c21266.jpg";